import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_TRANSPORTATION_UNIT_URL } from '../apiUrl';

const uploadMasterDataPreviewTransportationUnitApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_TRANSPORTATION_UNIT_URL, data);
};

export default uploadMasterDataPreviewTransportationUnitApi;
